// @flow

import { failure } from 'common/json/extract';
import type { JSONValue } from 'common/types';

export function exactly<V>(value: V): JSONValue => V {
  return (json: JSONValue) => {
    if (json === value) {
      return value;
    }
    return failure(
      `Expecting specific value of type ${typeof value}, got another value of type ${typeof json}`,
      () => value
    );
  };
}
